jQuery(document).ready(function($) {
	$.resizer = {
		resizeTimer        : null,
		resizeTimerNoChache: null,

		init: function() {
			$.resizer.events();
			$.resizer.resize(true);
		},

		events: function() {
			$(window).resize(function() {
				clearTimeout($.resizer.resizeTimer);
				$.resizer.resizeTimer = setTimeout($.resizer.resize, 200);

				clearTimeout($.resizer.resizeTimerNoChache);
				$.resizer.resizeTimerNoChache = setTimeout($.resizer.resizeNoCache, 30);
			});
		},

		resize: function(init) {
			//fire resizeevents
			$(document).trigger('resized', {});
		},

		resizeNoCache: function(init) {
			//fire resizeevents without a timer (be carefull !!!!)
			$(document).trigger('resized_nocache', {});
		}
	};
});
